var wFlag=window.innerWidth>750

if(!wFlag){
    const list = document.querySelector('.tornado_list');
    const items = list.querySelectorAll('.tornado_item');

    items.forEach((item, index) => {
        if (index >= 6) item.remove();
    });
}
$(()=>{
    //box1
    new Swiper('.box1Swiper', {
        autoplay:true,
        loop:true,
        pagination: {
            el: '.newSwiper-pagination',
            clickable:true
        },
        navigation: {
            nextEl: '.newSwiper-button-next',
            prevEl: '.newSwiper-button-prev',
        },
    })

    //box2
    if(wFlag){
        $('.box2_item').hover(function(){
            $(this).addClass('box2Active').siblings().removeClass('box2Active')
        })
    }else{
        new Swiper('.box2Swiper', {
            autoplay: true,
            loop:true,
            pagination: {
                el: '.box2Swiper-pagination',
                clickable :true,
            }
        })
    }

    //box3
    ScrollTrigger.create({
        trigger: '.box3_content',
        start: 'top bottom-=30%',
        end: '+=0%',
        //toggleActions: 'play none none reverse',
        animation: gsap.timeline().from('.box3_content div', { scale:0,duration:0.3,ease:'none' })
    });

    const box3 = document.querySelector('.box3');
    const shapes = document.querySelector('.shapes');
    
    gsap.set(".cursor", { xPercent: -50, yPercent: -50 });
    gsap.set(".shape", { xPercent: -50, yPercent: -50 });
    
    box3.addEventListener("mousemove", evt => {
        const mouseX = evt.clientX;
        const mouseY = evt.clientY;
    
        // 光标：用视口坐标（跟鼠标一模一样）
        gsap.to(".cursor", {
            x: mouseX,
            y: mouseY,
            duration: 0.1
        });
    
        // 大圆形：用相对 .shapes 容器的局部坐标
        const rect = shapes.getBoundingClientRect();
        const localX = mouseX - rect.left;
        const localY = mouseY - rect.top;
    
        gsap.to(".shape", {
            x: localX,
            y: localY,
            stagger: -0.1,
            duration: 0.6
        });
    });

    //box4
    new Swiper('.box4Swiper', {
        slidesPerView:wFlag?1.4:1,
        centeredSlides:true, 
        pagination: {
            el: '.box4Swiper-pagination',
            clickable :true,
        },
        loop:true,
        autoplay:{
            delay:5000
            // disableOnInteraction: false,
        },
        on:{
            slideChangeTransitionEnd: function(swiper){
                for(var i=0;i<$('.box4Swiper .box4_item video').length;i++){
                    if(i != $('.box4Swiper .swiper-slide-active').index()){
                        $('.box4Swiper .box4_item video')[i].pause()
                    }else{
                        $('.box4Swiper .swiper-slide-active')[0].children[0].children[0].play()
                    }
                }
                
                if(wFlag){
                    
                }else{
                    var realIndex = swiper.realIndex;
                    var slides = swiper.slides[realIndex];
                    // console.log(slides)
                    $(`.box4_info`).removeClass('showup')
                    slides.getElementsByClassName('box4_info')[0].classList.add('showup')
                }
            },
        },
    })

    //box5
    if(wFlag){
        ScrollTrigger.create({
            trigger: '.tornado_wrapper',
            start: 'top center',
            end: '+=0%',
            //toggleActions: 'play none none reverse',
            animation: gsap.timeline().from('.tornado_wrapper', { opacity:0,y:'2rem',duration:0.5,ease:'none' })
        });
    }else{
        new Swiper('.box5Swiper', {
            autoplay: true,
            loop:true,
            slidesPerView:1.5,
            centeredSlides:true, 
            pagination: {
                el: '.box5Swiper-pagination',
                clickable :true,
            }
        })
    }

    // $('.box4_text div:nth-child(2)').click(function(){
    //     var element = $(this).parents('.box4_item').children('video')[0]
    //     //是否全屏
    //     if(window.innerWidth>750){
    //         if(element.requestFullscreen){
    //             element.requestFullscreen()
    //         }
    //     }else{
    //         $(this).parents('.box4_item').find('.box4_mask').hide()
    //     }
    //     //播放结束
    //     element.addEventListener('ended', function(){
    //         if (element.exitFullscreen) {
    //             element.exitFullscreen();
    //         } else if (element.webkitExitFullscreen) {
    //             element.webkitExitFullscreen();
    //         } else if (element.mozCancelFullScreen) {
    //             element.mozCancelFullScreen();
    //         } else if (element.msExitFullscreen) {
    //             element.msExitFullscreen();
    //         }
    //         //进度条
    //         element.currentTime = 0;
    //     })
    
    // })

    //box5

})


function initTornado(wrapperSelector = ".tornado_wrapper") {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) return;
    const list  = wrapper.querySelector(".tornado_list");
    const cards = wrapper.querySelectorAll(".tornado_item");
    const pics  = wrapper.querySelectorAll(".teammate_pic");
    
    if (!cards.length) return;
    
    // 给头像略微上下错位（-25 / 0 / 25 循环）
    gsap.set(pics, {
        yPercent: i => gsap.utils.wrap([-25, 0, 25], i)
    });
    
    // 设置每个 item 的 transform-origin（圆柱半径）
    function setTransformOrigin() {
        const radius = -window.innerWidth * 0.45; // 和原站类似
        gsap.set(cards, {
            transformOrigin: `50% 50% ${radius}px`
        });
    }
    setTransformOrigin();
    
    // 无限旋转时间轴（只有旋转，没有进场）
    const spinTl = gsap.timeline({
        paused: true,         // 默认暂停，滚动到视口再播放
        repeat: -1,
        defaults: {
            ease: "none",
            duration: 30        // 一圈时长，可自行调
        }
    });
    
    // 均匀分布到 360° 上，然后整体 -=360 做无限旋转
    spinTl.fromTo(
    cards,
    {
        rotationY: i => (i * 360) / cards.length
    },
    {
        rotationY: "-=360"
    }
    );
    
    // ScrollTrigger 控制何时转、何时停
    ScrollTrigger.create({
        trigger: wrapper,
        scrub: true,
        invalidateOnRefresh: true,
        
        onToggle: self => {
            if (self.isActive) {
                spinTl.play();
            } else {
                spinTl.pause();
            }
        },
        
        onRefresh: () => {
            // resize 后重算 3D 场景
            setTransformOrigin();
            gsap.set(pics, {
                yPercent: i => gsap.utils.wrap([-25, 0, 25], i)
            });
        }
    });
    
    ScrollTrigger.refresh();
}

// DOM 准备好后初始化
document.addEventListener("DOMContentLoaded", () => {
    initTornado();
});